import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { MatSelectChange } from '@angular/material/select';
import { Router } from '@angular/router';
import { CURRENCY_LABEL, CustomEvents, DEFAULT_MAXIMUM_MULTIPLIER, FROM_BROKER_REDIRECT, MANAGE_BROKERS_PATH, MAXIMUM_MULTIPLIER_UNLIMITED, MIN_ABSOLUTE_VALUE, RETAIN_MULTIPLIER_CACHE_KEY, RUNNING_TYPE, STATIC_IP_OPENERS, STRATEGY_CREATION_METHOD, SVGPathMap, StorageHelper, Utils, WEEK_DAYS, ZERO_PLAN_LEVEL, isMastertrust, isPesb, isSwastika } from '@app/_helpers';
import { CANCEL_BUTTON_TEXT, CONFIRM_BUTTON_TEXT } from '@app/_helpers/confirmation-dialog.enums';
import { Formulas } from '@app/_helpers/formulas';
import { ConfirmationDialogService } from '@app/_shared/modules/confirmation-dialog/_provider/confirmation-dialog.service';
import { PortfolioCreationType } from '@app/_shared/modules/portfolio-form/portfolio-form.enums';
import { RegulatoryGuardService } from '@app/_shared/modules/regulatory-dialog/regulatory-guard.service';
import { PRODUCT_TYPE } from '@app/_shared/modules/strategy-form/strategy.enums';
import { AutoDeploymentStreamPayload, ConfigurationService, EventsService, ExecutePortfolioRequest, NgxToastrService, PortfolioService, RegulationResponse, StrategiesService, StrategySocketUpdateI, SubjectType } from '@app/_shared/providers';
import { MarginResponse } from '@app/_shared/providers/funds/funds.interface';
import { FundsService } from '@app/_shared/providers/funds/funds.service';
import { MIXPANEL_EVENTS } from '@app/_shared/providers/mixpanel/mixpanel.events';
import { MixpanelService } from '@app/_shared/providers/mixpanel/mixpanel.service';
import { BooksSocketService } from '@app/_shared/providers/websocket/books-socket/books-socket.service';
import { BROKER_CONNECTION_STATUS, PRODUCT_TYPE_NUM } from '@app/_shared/shared.enums';
import { DashboardDefaultStrategyType, RouteMap } from '@app/_shared/shared.structs';
import { CONFIRM_DEPLOY_STRATEGY, DEPLOY_DIALOG_TEXT, LIVE_AUTO_NOT_SELECTED, LIVE_SELECTED, LOW_BALANCE, MULTIPLIER_VALUE_EXCEEDS_ALLOWED_LIMIT, MULTIPLIER_VALUE_MUST_BE_GREATER_THAN_0, PLANS_DIALOG_TITLE, PRODUCT_TYPE_NOT_ALLOWED, REGULATORY_DISCLAIMER_TEXT, SUFFICIENT_BALANCE, UNABLE_TO_VERIFY_DEPLOYMENT_SETTINGS, UPGRADE_PLAN, ALGO_SPACE_MAPPING_REQUIRED, ALGO_SPACE_REQUIRED_SUBTEXT, ACTIVE_ALGO_LIMIT_REACHED, ALGO_SPACE_VM_DOWN, ALGO_SPACE_EXPIRED, ALGO_SPACE_PROVISIONING } from '@app/_shared/strings';
import { UserManagementService } from '@app/modules/admin/providers/user-management/user-management.service';
import { AuthService } from '@app/modules/auth';
import { MarketPlaceCardsType } from '@app/modules/trading/modules/dashboard/components/marketplace-cards/marketplace-cards.consts';
import { LoginFlowType } from '@app/modules/trading/modules/manage-brokers/manage-broker.enums';
import { AvailableBrokersResponse, ConnectedBroker, Vendor, AlgoSpace, ConnectedBrokersResponse, BrokersResponse } from '@app/modules/trading/modules/manage-brokers/manage-broker.interface';
import { ManageBrokerService } from '@app/modules/trading/modules/manage-brokers/manage-broker.service';
import { NonPartnerDirectLoginComponent } from '@app/modules/trading/modules/manage-brokers/non-partner-direct-login/non-partner-direct-login.component';
import { MarginCalculatorRequest, PeakMarginResponse } from '@app/modules/trading/modules/margin-calculator/providers/margin-calculator.interface';
import { MarginCalculatorService } from '@app/modules/trading/modules/margin-calculator/providers/margin-calculator.service';
import { BriefPortfolioModel } from '@app/modules/trading/modules/market-place/providers/market-place/market-place.models';
import { MarketPlaceService } from '@app/modules/trading/modules/market-place/providers/market-place/market-place.service';
import { MbPlansService } from '@app/modules/trading/modules/mb-plans/providers/mb-plans.service';
import { MyStrategyType } from '@app/modules/trading/modules/my-strategies/my-strategies.consts';
import { PRODUCT_ID } from '@app/modules/trading/modules/profile/components/funds/funds.enums';
import { CardSummary } from '@app/modules/trading/modules/profile/components/funds/funds.models';
import { PlansComponent } from '@app/modules/trading/modules/profile/components/plans/plans.component';
import { PORTFOLIO_PLAN_ERROR_CODES } from '@app/modules/trading/modules/profile/components/plans/plans.enums';
import { Observable, Subscription, of } from 'rxjs';
import { map, shareReplay, switchMap } from 'rxjs/operators';
import { BrokerConnectionStatus } from '../../../../../../utProto/enums_pb';
import { WebApiStrategyResponseType, WebApiStrategyRunningType, WebApiTransactionType } from '../../../../../../utProto/webApiStrategyEnums_pb';
import { DEPLOY_DIALOG_STRINGS } from '../../strategy-card.string';

@Component({
    selector: 'app-deploy-dialog',
    templateUrl: './deploy-dialog.component.html',
    styleUrls: ['./deploy-dialog.component.scss']
})
export class DeployDialogComponent implements OnInit, OnDestroy {

    parametersForm: UntypedFormGroup;
    WebApiStrategyRunningType = WebApiStrategyRunningType;
    CURRENCY_LABEL = CURRENCY_LABEL;
    CONFIRM_DEPLOY_STRATEGY = CONFIRM_DEPLOY_STRATEGY;
    totalMargin = 0;
    minCash = 0;
    showMarginPage = true;
    lowBalance = false;
    isVendorLogin = false;
    LOW_BALANCE = LOW_BALANCE;
    SUFFICIENT_BALANCE = SUFFICIENT_BALANCE;
    DEPLOY_DIALOG_STRINGS = DEPLOY_DIALOG_STRINGS;
    cardData: CardSummary;
    multiplierRange = [];
    utradeOriginals = DashboardDefaultStrategyType.ORIGINALS;
    MIN_ABSOLUTE_VALUE = MIN_ABSOLUTE_VALUE;
    showMultiplierError = false;
    private subscriptions = new Subscription();
    isPortfolioQueued: boolean = false;
    isDeployDisabled: boolean = false;
    sufficientBalance: boolean = false;
    vendorImagePath: string = isSwastika ? SVGPathMap.swastika_logo : isMastertrust ? SVGPathMap.mastertrust_logo : isPesb ? SVGPathMap.pesb_logo : SVGPathMap.shareIndia_logo;
    isSwastikaLogin: boolean = isSwastika;
    isMasterTrustLogin: boolean = false;
    isPesbLogin: boolean = false;
    singleLegMarginRequest: MarginCalculatorRequest
    isPlanAutoDeploy: boolean ;
    RUNNING_TYPE = RUNNING_TYPE;
    isAutoOnInSetExit: boolean;
    autoDeploymentDays: any[];
    balanceChecked: boolean = false;
    isPublicCopy: boolean = false;
    isCreator: boolean;
    selfPublic: boolean;
    preventEvent = Utils.preventEvent;
    DEPLOY_DIALOG_TEXT = DEPLOY_DIALOG_TEXT;
    disclaimer_algo_trading: string;
    disclaimer_stop_loss: string;
    userName: string;
    isOriginals: boolean;
    isCopyOfOriginals: boolean;
    isTempPortfolio: boolean;
    isCarryforwardAllowed: boolean = false;
    STRATEGY_CREATION_METHOD = STRATEGY_CREATION_METHOD;
    isForwardAllowedInPlan: boolean;
    fundsNewFormula: boolean = false;
    MAXIMUM_MULTIPLIER_UNLIMITED = MAXIMUM_MULTIPLIER_UNLIMITED;
    showUnlimitedMultiplier: boolean = false;
    retainMultiplier: number = 0;
    retainMultiplierEnabled: boolean = false;
    connectedBrokers: ConnectedBroker[] = [];
    brokersData: { [key: string]: Vendor};
    dotColor: string;
    BROKER_CONNECTION_STATUS_STRING = BROKER_CONNECTION_STATUS;
    selectedBroker: ConnectedBroker | null = null;
    BROKER_CONNECTION_STATUS = BrokerConnectionStatus;
    isForwardSelected: boolean = false;
    availableBrokers: AvailableBrokersResponse;
    regulatoryData$: Observable<RegulationResponse> | null = null;
    isCheckingGlobalExit: boolean = false;
    multiBrokerAllowed: boolean = false;
    isRegulationComplianceEnabled: boolean = false;
    selectedAlgoSpaceId: string | null = null;
    blockedSpaceIds = new Set<string>();
    algoSpacePickerBlockMessages = new Map<string, string>();

    ALGO_SPACE_MAPPING_REQUIRED = ALGO_SPACE_MAPPING_REQUIRED;
    ALGO_SPACE_REQUIRED_SUBTEXT = ALGO_SPACE_REQUIRED_SUBTEXT;
    ACTIVE_ALGO_LIMIT_REACHED = ACTIVE_ALGO_LIMIT_REACHED;
    ALGO_SPACE_VM_DOWN = ALGO_SPACE_VM_DOWN;
    ALGO_SPACE_EXPIRED = ALGO_SPACE_EXPIRED;
    ALGO_SPACE_PROVISIONING = ALGO_SPACE_PROVISIONING;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: { portfolio: BriefPortfolioModel, type: MarketPlaceCardsType | MyStrategyType },
        private toastr: NgxToastrService,
        private portfolioService: PortfolioService,
        private dialogRef: MatDialogRef<DeployDialogComponent>,
        private confirmationService: ConfirmationDialogService,
        public authService: AuthService,
        private dialog: MatDialog,
        private marginService: MarginCalculatorService,
        private fundsService: FundsService,
        public configService: ConfigurationService,
        public manageBrokerService: ManageBrokerService,
        private socketService: BooksSocketService,
        private eventService: EventsService,
        private strategyService: StrategiesService,
        private userManagementService: UserManagementService,
        private router: Router,
        private mixpanel: MixpanelService,
        private mbPlansService: MbPlansService,
        private regulatoryGuardService: RegulatoryGuardService,
        private marketplaceService: MarketPlaceService,
    ) {
        this.userName = this.authService?.accessTokenObj?.clientId;
        this.configService.getServerConfig().subscribe((res)=>{
            this.isCarryforwardAllowed = !!parseInt(res.config_params.CF_PRODUCT_ENABLE);
        })
        this.parametersForm = new UntypedFormGroup({
            multiplier: new UntypedFormControl(null, Validators.required),
            strategyType: new UntypedFormControl(RUNNING_TYPE.LIVE, Validators.required)
        })

        this.subscriptions.add(
            this.socketService.getSubject(SubjectType.STRATEGY).subscribe((res: StrategySocketUpdateI) => {
                if (res.webApiStrategyResponseType === WebApiStrategyResponseType.WEBAPISTRATEGYRESPONSE_SUCCESSFUL
                    || res.webApiStrategyResponseType === WebApiStrategyResponseType.WEBAPISTRATEGYRESPONSE_TERMINATE_SUCCESS) {
                    this.isPortfolioQueued = false;
                }
            })
        )

        this.subscriptions.add(
            this.socketService.getSubject(SubjectType.AUTODEPLOYMENT).subscribe((payload: AutoDeploymentStreamPayload) => {
                if (payload.autoDeploymentDetails.portfolioID === this.data.portfolio.portfolioID) {
                    this.isAutoOnInSetExit = payload.autoDeploymentDetails.autoDeployPortfolio;
                    this.autoDeploymentDays = payload.autoDeploymentDetails.autoDeploymentDays;
                }
            })
        )

        this.portfolioService.getSingleBreifPortfolio(data.portfolio.portfolioID, false , true).subscribe((res) => {
            this.isPortfolioQueued = res.isQueued;
        });

        this.isMasterTrustLogin = this.authService.isMasterTrustLogin; 
        this.isPesbLogin = this.authService.isPesbLogin;
    }


    ngOnInit(): void {
        this.isRegulationComplianceEnabled = this.configService.remoteConfigCacheObj?.IS_REGULATORY_COMPLIANCE_ENABLED;
        this.fundsNewFormula = this.configService.remoteConfigCacheObj?.FUNDS_NEW_FORMULA;
        this.multiBrokerAllowed = this.configService.remoteConfigCacheObj?.MULTI_BROKER_ALLOWED ?? true;

        this.cardData = new CardSummary(PRODUCT_ID.ALL);
        this.isVendorLogin = this.authService.isVendorLogin;
        this.disclaimer_algo_trading = this.configService?.remoteConfigCacheObj?.DISCLAIMER_ALGO_TRADING;
        this.disclaimer_stop_loss = this.configService?.remoteConfigCacheObj?.DISCLAIMER_STOP_LOSS;
        this.isCreator = this.authService.accessTokenObj?.clientId.toUpperCase() === this.data.portfolio.creator.toUpperCase();
        this.selfPublic = this.isCreator && this.data.portfolio.isPublic;
        this.isTempPortfolio = this.data.portfolio.creationMethod === STRATEGY_CREATION_METHOD.TVPORTFOLIO;
        if (this.isVendorLogin) {
            this.getBalance();
        } else {
            this.showMarginPage = false
        }
        if(this.isRegulationComplianceEnabled){
            this.regulatoryData$ = this.portfolioService.checkPortfolioRegulation([this.data.portfolio.portfolioID]).pipe(shareReplay(1));
            this.subscriptions.add(this.regulatoryData$.subscribe());
        }

        this.subscriptions.add(
            this.mbPlansService.getCurrentPlan().subscribe((res) => {
                this.isForwardAllowedInPlan = res.plan.forward_testing;
                this.isPlanAutoDeploy = res.plan.auto_deployment;
            })
        );
        this.subscriptions.add(
            this.portfolioService.getSingleBreifPortfolio(this.data.portfolio.portfolioID).subscribe((response) => {
            this.data.portfolio = {
                ...this.data.portfolio,
                strategies: response.strategies
            } as BriefPortfolioModel;

            this.retainMultiplier = this.portfolioService.retainMultiplier;

            this.isOriginals = this.data.portfolio.isPublic && this.data.portfolio.creator !== this.userName;
            this.isCopyOfOriginals = this.data.portfolio.originalPortfolioDetails && this.data.portfolio.originalPortfolioDetails.length && this.data.portfolio.originalPortfolioDetails[0]?.isPublic;
            
            if (this.data?.portfolio?.isPublic || (this.data?.portfolio?.originalPortfolioDetails?.length && this.data?.portfolio?.originalPortfolioDetails[0]?.isPublic) || this.data?.portfolio?.creationMethod === STRATEGY_CREATION_METHOD.CPP_TYPE) {
                // this.portfolioService.getSingleDetailPortfolio(this.data.portfolio.portfolioID).subscribe((response) => {
                this.totalMargin = response.minimumCapital;
                this.minCash = response.minCash;
                this.checkBalance();
                // });
            } else {
                this.fetchMargin(false);
            }

            if (this.data.portfolio.subscribed) {
                this.subscriptions.add(
                    this.portfolioService.getExitParams(this.data.portfolio.portfolioID).subscribe(response => {
                        if (response.portfolio) {
                            this.setAutoDeployValues(response.portfolio);
                        }    
                    })
                );
            } else {
                this.subscriptions.add(
                    this.portfolioService.getSingleBreifPortfolio(this.data.portfolio.portfolioID).subscribe((resp) => {
                        this.setAutoDeployValues(resp);
                    })
                );
            }

            this.subscriptions.add(
                this.mbPlansService.getCurrentPlan().subscribe(res => {

                if (isSwastika || this.isMasterTrustLogin) {
                    // In case of Swastika, plan multipliers not to be considered
                    this.multiplierRange = [this.data.portfolio.minimumMultiplier, this.data.portfolio.maximumMultiplier];
                } else {
                    //when portfolio is public we are assigning multipliers from plans.
                    if (res.plan.max_multiplier == MAXIMUM_MULTIPLIER_UNLIMITED) {
                        this.showUnlimitedMultiplier = true;
                    }
                    this.multiplierRange = Utils.getUnionOfRanges([res.plan.min_multiplier, res.plan.max_multiplier],
                        [this.data.portfolio.minimumMultiplier, this.data.portfolio.maximumMultiplier])
                }

                //when portfolio is not public:
                //- case1: It is not public or it is a copy of non-public.
                //- case2: It is a copy of public portfolio.
                //In these cases we are assigning default value for multipliers.
                if (!this.data.portfolio.isPublic && (!this.data.portfolio.originalPortfolioDetails?.length ||
                    (this.data.portfolio.originalPortfolioDetails?.length && !this.data.portfolio.originalPortfolioDetails[0]?.isPublic))) {
                    this.multiplierRange = [1, DEFAULT_MAXIMUM_MULTIPLIER];
                }

                //when intersection not happen b/w portfolio multipliers and plan multipliers we are disabling multiplier field
                if (this.multiplierRange[0] >= this.multiplierRange[1]) {
                    this.parametersForm.get('multiplier').disable();
                    //- Condition when max portfolio multiplier is greater than max plan multiplier we are assigning multilplier
                    //  value as min value of portfolio multiplier and max for reverse case
                    //- For e.g portfolio multipliers are [3,10] and plan multipliers are [1,2] then we will assign multiplier
                    //  value as 3
                    if (this.data.portfolio.maximumMultiplier > res.plan.max_multiplier) {
                        this.parametersForm.get('multiplier').setValue(this.data.portfolio.minimumMultiplier);
                    } else {
                        this.parametersForm.get('multiplier').setValue(this.data.portfolio.maximumMultiplier);
                    }
                } else {
                    if (this.retainMultiplier) {
                        this.parametersForm.get('multiplier').setValue(this.retainMultiplier);
                    } else {
                        this.parametersForm.get('multiplier').setValue(this.multiplierRange[0]);
                    }
                }
                // when ever multiplierRange changes we need to check balance
                this.checkBalance();

                this.parametersForm.get('multiplier').setValidators([Validators.required,
                Validators.min(this.multiplierRange[0]), Validators.max(this.multiplierRange[1])])

                this.parametersForm.get('multiplier').updateValueAndValidity();
                // Check Balance on Multiplier change
                this.subscriptions.add(
                    this.parametersForm.get('multiplier').valueChanges.subscribe(val => {
                        this.checkBalance();
                    })
                );
            })
        );
        })
        );
        this.subscriptions.add(
            this.userManagementService.getCache(RETAIN_MULTIPLIER_CACHE_KEY).subscribe((res: any)=>{
                if (res.data) {
                    this.retainMultiplierEnabled = JSON.parse(res.data);
                }
            })
        );

        this.loadDeployBrokerData();
        this.subscriptions.add(
            this.socketService.getSubject(SubjectType.BROKER_CONNECTION_SNAPSHOT).subscribe(() => {
                this.loadDeployBrokerData();
            })
        )
        this.subscriptions.add(
            this.socketService.getSubject(SubjectType.BROKER_CONNECTION_UPDATE).subscribe((res) => {
                const index = this.connectedBrokers.findIndex(broker => broker.broker === res.broker && broker.broker_id === res.broker_id);
                if (index !== -1) {
                    this.connectedBrokers[index] = res as ConnectedBroker;
                    this.syncSelectedBroker();
                }
            })
        )
        this.subscriptions.add(
            this.socketService.getSubject(SubjectType.BROKER_CREDENTIALS_UPDATE).subscribe((res) => {
                const index = this.connectedBrokers.findIndex(broker => broker.broker === res.broker && broker.broker_id === res.broker_id);
                if (res.status === BrokerConnectionStatus.CONNECTIONSTATUS_KEYDELETED) {
                    if (index !== -1) {
                        this.connectedBrokers.splice(index, 1);
                    }
                } else {
                    if (index === -1) {
                        this.connectedBrokers.push(res as ConnectedBroker);
                    } else {
                        this.connectedBrokers[index] = res as ConnectedBroker;
                    }
                }
                this.syncSelectedBroker();
            })
        )
    }

    private syncSelectedBroker(): void {
        if (this.isForwardSelected) {
            return;
        }
        const selectedBrokerId = this.selectedBroker?.broker_id;
        const selectedBrokerName = this.selectedBroker?.broker;
        if (selectedBrokerId && selectedBrokerName) {
            const updated = this.connectedBrokers.find(
                broker => broker.broker === selectedBrokerName && broker.broker_id === selectedBrokerId
            );
            if (updated?.status === BrokerConnectionStatus.CONNECTIONSTATUS_ACTIVE) {
                this.selectedBroker = updated;
                this.syncSelectedAlgoSpace();
                return;
            }
        }
        this.selectedBroker = this.connectedBrokers.find(
            broker => broker.status === BrokerConnectionStatus.CONNECTIONSTATUS_ACTIVE
        ) ?? null;
        this.syncSelectedAlgoSpace();
    }

    getConnectedBrokers() {
        this.manageBrokerService.getConnectedBrokers().subscribe((res: ConnectedBrokersResponse) => {
          this.connectedBrokers = [...res.data];
          this.syncSelectedBroker();
        });
    
        this.manageBrokerService.getBrokers().subscribe((res: BrokersResponse) => {
          this.brokersData = res.login_flows;
        });

        this.manageBrokerService.getAvailableBrokers().subscribe((res: AvailableBrokersResponse) => {
          this.availableBrokers = res;
        });
    }

    loadDeployBrokerData(): void {
        this.manageBrokerService.getDeployDialogBrokerData().subscribe(({ connectedBrokers, brokersData, availableBrokers }) => {
            const selectedBrokerId = this.selectedBroker?.broker_id;
            this.connectedBrokers = connectedBrokers;
            this.brokersData = brokersData;
            this.availableBrokers = availableBrokers;
            this.selectedBroker = this.connectedBrokers.find((broker) => broker.broker_id === selectedBrokerId)
                ?? this.connectedBrokers.find((broker) => broker.status === BrokerConnectionStatus.CONNECTIONSTATUS_ACTIVE)
                ?? null;
            this.syncSelectedAlgoSpace();
        });
    }

    async fetchMargin(isOriginals: boolean = true) {
        const ltpMap: Map<string, number> = new Map();
        this.portfolioService.getSingleBreifPortfolio(this.data.portfolio.portfolioID).subscribe(async (response) => {
            for (let i = 0; i < response.strategies.length; i++) {
                const strategy = response.strategies[i];
                const ltpMapKey = `${strategy.strategySymbol.symbol}_${strategy.underlying}`;
                if (!ltpMap.has(ltpMapKey)) {
                    const ltp = await this.marginService.getUnderlyingLTP(strategy.strategySymbol.symbol, strategy.underlying, parseInt(strategy.strategySymbol.exchange));
                    ltpMap.set(ltpMapKey, ltp);
                };
            };
            this.singleLegMarginRequest = await this.marginService.prepareLegsForMarginCalculations(response.strategies, ltpMap);
             // not required to calculate peak margin for custom portfolio as per ticket UT-3221
            if (isOriginals) {
                this.marginService.calculatePeakMargin(this.singleLegMarginRequest).toPromise().then((margin: PeakMarginResponse) => {
                    this.totalMargin = margin.total_margin;
                    this.minCash = margin.min_cash;
                    this.checkBalance();
                });
            } else {
                this.marginService.calculateRequiredMargin(this.data.portfolio.portfolioID).subscribe((res) => {
                    if (res) {
                        this.totalMargin = res.aggregate_margin.total || 0;
                    }
                });
            }
        });

    }

    prepareLegsCalculation() {
        if (this.singleLegMarginRequest?.portfolios?.length){
            const array = this.singleLegMarginRequest.portfolios;
            window.open(`${window.location?.origin}/trading/margin-calculator?portfolios=${encodeURI(JSON.stringify(array))}`, '_blank');
        }
    }
    
    setAutoDeployValues(portfolio) {
        this.isAutoOnInSetExit = portfolio.autoDeployPortfolio;
        this.autoDeploymentDays = portfolio.autoDeploymentDays;
        if (this.isAutoOnInSetExit) {
            this.parametersForm.get('strategyType').setValue(RUNNING_TYPE.LIVEAUTO);
        }
    }

    getBrokerConnectionStatusClass(status: number) {
        if (status === BrokerConnectionStatus.CONNECTIONSTATUS_ACTIVE) {
          this.dotColor = 'green-dot';
          return 'text-green';
        } else if (status === BrokerConnectionStatus.CONNECTIONSTATUS_LOGGEDOUT) {
          this.dotColor = 'grey-dot';
          return 'placeholder-text';
        } else if (status === BrokerConnectionStatus.CONNECTIONSTATUS_INACTIVE) {
          this.dotColor = 'negative-dot';
          return 'text-negative';
        }
      }
    
    getBrokerConnectionStatusDot(status: number) {
        if (status === BrokerConnectionStatus.CONNECTIONSTATUS_ACTIVE) {
          return 'green-dot';
        } else if (status === BrokerConnectionStatus.CONNECTIONSTATUS_LOGGEDOUT) {
          return 'grey-dot';
        } else if (status === BrokerConnectionStatus.CONNECTIONSTATUS_INACTIVE) {
          return 'warning-dot';
        }
    }

    selectBroker(broker: ConnectedBroker | null, isForward: boolean = false) {
        if (isForward) {
            this.isForwardSelected = true;
            this.selectedBroker = null;
            this.selectedAlgoSpaceId = null;
            this.refreshAlgoSpacePickerBlockState();
            return;
        }
        if (broker.status !== this.BROKER_CONNECTION_STATUS.CONNECTIONSTATUS_ACTIVE) {
            this.toastr.simpleCustomToaster('Please connect to a broker to deploy');
            return;
        }
        this.isForwardSelected = false;
        this.selectedBroker = broker;
        this.syncSelectedAlgoSpace();
    }

    syncSelectedAlgoSpace(): void {
        const spaces = this.selectedBroker?.algo_spaces ?? [];
        if (!spaces.length) {
            this.selectedAlgoSpaceId = null;
            this.refreshAlgoSpacePickerBlockState();
            return;
        }
        const current = this.selectedAlgoSpaceId;
        const preferred = spaces.find((space) => space.id === current && this.manageBrokerService.isAlgoSpaceDeployable(space))
            ?? spaces.find((space) => this.manageBrokerService.isAlgoSpaceDeployable(space))
            ?? spaces[0];
        this.selectedAlgoSpaceId = preferred?.id ?? null;
        this.refreshAlgoSpacePickerBlockState();
    }

    onAlgoSpaceOptionClick(space: AlgoSpace, event?: Event): void {
        event?.stopPropagation();
        if (this.blockedSpaceIds.has(space.id)) {
            return;
        }
        this.selectAlgoSpace(space.id, event);
    }

    selectAlgoSpace(spaceId: string, event?: Event): void {
        event?.stopPropagation();
        if (this.blockedSpaceIds.has(spaceId)) {
            return;
        }
        this.selectedAlgoSpaceId = spaceId;
    }

    private refreshAlgoSpacePickerBlockState(): void {
        this.blockedSpaceIds = new Set();
        this.algoSpacePickerBlockMessages = new Map();
        const spaces = this.selectedBroker?.algo_spaces ?? [];
        for (const space of spaces) {
            const message = this.manageBrokerService.getAlgoSpaceDeployError(this.selectedBroker, space, false);
            if (message) {
                this.blockedSpaceIds.add(space.id);
                this.algoSpacePickerBlockMessages.set(space.id, message);
            }
        }
    }

    get selectedAlgoSpace(): AlgoSpace | null {
        return this.manageBrokerService.getSelectedAlgoSpace(this.selectedBroker, this.selectedAlgoSpaceId);
    }

    isDeployBlockedByAlgoSpace(): boolean {
        return !!this.manageBrokerService.getAlgoSpaceDeployError(this.selectedBroker, this.selectedAlgoSpace, this.isForwardSelected);
    }

    openMapAlgoSpaceDialog(): void {
        if (!this.selectedBroker) {
            return;
        }
        this.manageBrokerService.openMapAlgoSpaceDialog(this.dialog, this.selectedBroker, STATIC_IP_OPENERS.DEPLOY_DIALOG, () => {
            this.loadDeployBrokerData();
        });
    }

    loginBroker(isReLogin: boolean = false , broker: ConnectedBroker): void {
        if (!this.manageBrokerService.isBrokerConnectionAllowed(broker.broker)) {
            this.toastr.simpleCustomToaster(this.configService.remoteConfigCacheObj?.BROKER_NOT_AVAILABLE_MESSAGE , false);
            return;
        }
        const preferredSpaceId = broker.broker_id === this.selectedBroker?.broker_id
            ? this.selectedAlgoSpaceId
            : this.manageBrokerService.resolveLoginSpaceId(broker);
        const loginBlock = this.manageBrokerService.getLoginAlgoSpaceBlockReason(broker, preferredSpaceId);
        if (loginBlock) {
            this.toastr.simpleCustomToaster(loginBlock, false);
            return;
        }
        StorageHelper.isFromDeployedPage = {
            portfolioId: this.data?.portfolio?.portfolioID,
            comingFrom: this.router.url.includes('portfolio-overview') ? FROM_BROKER_REDIRECT.OVERVIEW : FROM_BROKER_REDIRECT.DEPLOYED,
            type: this.data?.type ? this.data?.type : MyStrategyType.Created
        };
        if (this.brokersData[broker.broker].available_flows[0].login_flow_type === LoginFlowType.OAUTH_DIRECT) {
          this.initMultiBrokerSocialLogin(this.brokersData[broker.broker]);
        } else if (this.brokersData[broker.broker].available_flows[0].login_flow_type === LoginFlowType.DIRECT_AFTER_LOGIN && (this.availableBrokers[broker.broker].metadata.length || this.availableBrokers[broker.broker].login_fields.length === 0)) {
          this.manageBrokerService.directLoginBroker(broker, null, preferredSpaceId).subscribe((response) => {
            this.toastr.simpleCustomToaster(response.message);
          }, (error) => {
            this.toastr.simpleCustomToaster(error?.error?.message, false);
          });
        } else if (this.brokersData[broker.broker].available_flows[0].login_flow_type === LoginFlowType.DIRECT_AFTER_LOGIN && !this.availableBrokers[broker.broker].metadata.length) {
            this.dialog.open(NonPartnerDirectLoginComponent, {
              width: '490px',
              panelClass: ['broker-selection-dialog'],
              data: {
                brokerDetails: this.availableBrokers[broker.broker],
                broker: broker,
              }
            }).afterClosed().subscribe((result) => {
              if (result) {
                this.manageBrokerService.directLoginBroker(broker, result, preferredSpaceId).subscribe((response) => {
                  this.toastr.simpleCustomToaster(response.message);
                }, (error) => {
                  this.toastr.simpleCustomToaster(error?.error?.message, false);
                });
              }
            });
          } else {
          this.manageBrokerService.initOAuthLogin(broker, preferredSpaceId).subscribe((response) => {
            window.open(response.login_url, '_self');
          }, (error) => {
            this.toastr.simpleCustomToaster(error?.error?.message, false);
          });
        }
    
        try {
          const mixpanelEvent = isReLogin ? MIXPANEL_EVENTS.RE_LOGIN_BROKER : MIXPANEL_EVENTS.CONNECT_BROKER;
          this.mixpanel.track(mixpanelEvent, {
            broker: broker?.broker,
            ucc: broker?.broker_id,
            static_ip: broker.algo_spaces?.map((space) => space.reserved_ip) ?? []
          });
        } catch (error) { }
      }

      initMultiBrokerSocialLogin(broker: Vendor) {
        this.authService.initMultiBrokerLogin(broker.vendor_name).subscribe(res => {
          if (res && res.login_url) {
            let authLink = res.login_url;
            location.replace(authLink);
          }
          else {
            this.toastr.simpleCustomToaster(res.error, false); // Error
          }
        })
      }

    executeAlgo() {
        // Prevent concurrent executions
        if (this.isCheckingGlobalExit) {
            return;
        }

        // Zero Plan Check
        if (this.mbPlansService.currentPlan?.plan?.level === ZERO_PLAN_LEVEL) {
            this.eventService.publish(CustomEvents.CREDITS_EXHAUSTED);
            return;
        }


        if (this.parametersForm.get('multiplier').value > this.multiplierRange[1]) {
            this.toastr.simpleCustomToaster(MULTIPLIER_VALUE_EXCEEDS_ALLOWED_LIMIT, false);
            return;
        }

        if (this.parametersForm.get('multiplier').value <= 0) {
            this.toastr.simpleCustomToaster(MULTIPLIER_VALUE_MUST_BE_GREATER_THAN_0, false);
            return;
        }

        if (this.isForwardSelected && Utils.isBSESelected(this.data.portfolio?.strategies[0]?.strategySymbol?.exchange.toString())) {
            this.toastr.simpleCustomToaster('Forward Testing is not supported for BSE.',false);
            return;
        }

        if (!this.manageBrokerService.isBrokerConnectionAllowed(this.selectedBroker?.broker)) {
            this.toastr.simpleCustomToaster(this.configService.remoteConfigCacheObj?.BROKER_NOT_AVAILABLE_MESSAGE , false);
            return;
        }

        const algoSpaceError = this.manageBrokerService.getAlgoSpaceDeployError(this.selectedBroker, this.selectedAlgoSpace, this.isForwardSelected);
        if (algoSpaceError) {
            this.toastr.simpleCustomToaster(algoSpaceError, false);
            return;
        }

        this.isCheckingGlobalExit = true;
        this.subscriptions.add(
        this.marketplaceService.checkGlobalExitBeforeDeployment(this.data.portfolio?.portfolioName, this.isForwardSelected)
            .pipe(
                switchMap(result => {
                    if(result.canDeploy) return of({proceed: true});
                    if(result.dialogRef) return result.dialogRef.afterClosed().pipe(map(() => ({proceed: false, closeDialog: true})));
                    return of({proceed: false, showError: true});
                    })
            ).subscribe(({proceed, showError, closeDialog}: {proceed: boolean, showError: boolean, closeDialog: boolean}) => {
                this.isCheckingGlobalExit = false;
                if (proceed) {
                    this.proceedWithDeployment();
                    return;
                }
                if (closeDialog){
                    this.dialogRef.close();
                    return;
                }
                if (showError) this.toastr.simpleCustomToaster(UNABLE_TO_VERIFY_DEPLOYMENT_SETTINGS, false);
            }, (error) => {
                console.error('Error checking global exit status:', error);
                this.isCheckingGlobalExit = false;
            }));
    }
    

    private async proceedWithDeployment() {
        switch (this.data.portfolio?.productType && this.data.portfolio?.productType[0]?.productType || this.data.portfolio?.strategies[0]?.productType) {
            case PRODUCT_TYPE_NUM.CARRYFORWARD:
                if (!this.isCarryforwardAllowed || !this.mbPlansService.isCarryForwardAllowed) {
                    this.toastr.simpleCustomToaster(PRODUCT_TYPE_NOT_ALLOWED(PRODUCT_TYPE.CARRYFORWARD));
                    return;
                }
                break;
            case PRODUCT_TYPE_NUM.INTRADAY:
                if (!this.mbPlansService.isIntradayAllowed) {
                    this.toastr.simpleCustomToaster(PRODUCT_TYPE_NOT_ALLOWED(PRODUCT_TYPE.INTRADAY));
                    return;
                }
                break;
        }
        if (this.multiplierRange[1] < this.multiplierRange[0]) {
            this.showMultiplierError = true;
            return;
        }
        if (this.parametersForm.valid) {
            const multiplier = this.parametersForm.get('multiplier').value;
            let isUnderRegulation = false;
            let regulatoryConfirmation = false;
            const regRes = this.regulatoryData$ ? await this.regulatoryData$.toPromise() : null;
            const regData = regRes?.regulatory_data || [];
            if (regData.length && this.selectedBroker?.broker && this.availableBrokers[this.selectedBroker?.broker]?.is_regulation_enabled) {
                isUnderRegulation = true;
                regulatoryConfirmation = await this.regulatoryGuardService.confirmIfRegulated(regData, REGULATORY_DISCLAIMER_TEXT(false));
            }

            const request: ExecutePortfolioRequest = {
                multiplier,
                running_type: this.isForwardSelected ? WebApiStrategyRunningType.WEBAPISTRATEGYRUNNINGTYPE_PAPERTRADE : WebApiStrategyRunningType.WEBAPISTRATEGYRUNNINGTYPE_LIVE,
                state: WebApiTransactionType.WEBAPITRANSACTIONTYPE_NEW,
                broker: this.selectedBroker?.broker,
                broker_id: this.selectedBroker?.broker_id,
                space_id: this.selectedAlgoSpace?.id,
                unique_portfolio_id: this.data.portfolio?.uniquePortfolioID,
                margin_required: Math.floor(this.totalMargin * 100) * multiplier,
                min_cash_required: Math.floor(this.minCash * 100) * multiplier,
                to_retain_multiplier: this.retainMultiplierEnabled,
            }

            if (this.isPlanAutoDeploy) {
                request.autoDeployPortfolio = this.parametersForm.get('strategyType').value === RUNNING_TYPE.LIVEAUTO ;
            }
            if(isUnderRegulation) {
                request.regulatory_confirmation = !!regulatoryConfirmation;
            }
            const isLiveAuto = this.parametersForm.get('strategyType').value === RUNNING_TYPE.LIVEAUTO;
            let messageString = CONFIRM_DEPLOY_STRATEGY;
            let confirmButtonText = CONFIRM_BUTTON_TEXT.confirm;
            let showLiveAutoDialog = false;

            if (isLiveAuto) {
                showLiveAutoDialog = true;
                this.mbPlansService.getCurrentPlan().subscribe((res) => {
                    const startIndex = res.plan.auto_deployment_start_day;
                    let days = [ ...WEEK_DAYS.slice(startIndex - 1).concat(WEEK_DAYS.slice(0,startIndex - 1))];
                    messageString = LIVE_SELECTED + days + "<br>" + CONFIRM_DEPLOY_STRATEGY;
                    confirmButtonText = CONFIRM_BUTTON_TEXT.default;
                })
            } else if (this.isAutoOnInSetExit && !isLiveAuto) {
                showLiveAutoDialog = true;
                messageString = LIVE_AUTO_NOT_SELECTED + CONFIRM_DEPLOY_STRATEGY;
                confirmButtonText = CONFIRM_BUTTON_TEXT.default;
            }

            const portfolio = this.data.portfolio;
            const originalPortfolioName = portfolio.originalPortfolioDetails?.length ? portfolio.originalPortfolioDetails[0]?.portfolioName : '';
            if (portfolio.portfolioCreationType === PortfolioCreationType.Copy && portfolio.originalPortfolioDetails
                && portfolio.originalPortfolioDetails.length && (portfolio.originalPortfolioDetails[0].version ?? 0) !== portfolio.version) {
                messageString = Utils.getMessageString(originalPortfolioName) + messageString;
                confirmButtonText = CONFIRM_BUTTON_TEXT.default;
            }

            let updateCopyPortfolioVersion = () => {
                if (portfolio.portfolioCreationType === PortfolioCreationType.Copy && portfolio.originalPortfolioDetails
                    && portfolio.originalPortfolioDetails.length && portfolio.originalPortfolioDetails[0].version !== portfolio.version) {
                    this.portfolioService.updateCopyPortfolioVersion(portfolio.portfolioID, portfolio).subscribe();
                    this.eventService.publish(CustomEvents.changeCopyPortfolioId, portfolio.portfolioID);
                }
            }

            let executeFunction = () => {
                this.portfolioService.updatePortfolioState(request, this.data.portfolio.portfolioID).subscribe(res => {
                    if (res.message && PORTFOLIO_PLAN_ERROR_CODES.includes(res.errorCode)) {
                        this.toastr.clickableCustomToaster(res.message, UPGRADE_PLAN, RouteMap.plans);
                    } else if (res.message) {
                        this.toastr.simpleCustomToaster(res.message);
                    }
                    if (res.amdDeployed) {
                        this.strategyService.strategyListUpdated.emit();
                    }
                    this.fireMixpanelEvent(MIXPANEL_EVENTS.DEPLOY_STRATEGY_SUCCESS, multiplier);
                    this.dialogRef.close(true);
                }, error => {
                    this.fireMixpanelEvent(MIXPANEL_EVENTS.DEPLOY_STRATEGY_FAILURE, multiplier, error?.error ?? error);
                })
                updateCopyPortfolioVersion();
            };
            if(isUnderRegulation && !showLiveAutoDialog) {
                executeFunction();
                return;
            }
            const params = Utils.confirmationDialogParams(messageString, executeFunction, updateCopyPortfolioVersion, CANCEL_BUTTON_TEXT.default, confirmButtonText);
            this.confirmationService.alert(params);
        }
    }

    fireMixpanelEvent(event: string, multiplier: number, error?: any) {
        try {
            const mpData: Record<string, any> = {
                multiplier_value: multiplier,
                broker_name: this.selectedBroker?.broker || "Forward Testing",
                portfolio_name: this.data?.portfolio?.portfolioName,
                type: Utils.isAIGeneratedPortfolio(this.data.portfolio) ? "AI Generated" : this.data.portfolio?.isPublic ? "Original" : "Custom",
                product_type: Utils.getProductTypeString(this.data.portfolio?.strategies?.[0]?.productType),
                static_ip: this.selectedAlgoSpace?.reserved_ip
            }
            if (error) {
                mpData.error = error;
            }
            this.mixpanel.track(event, mpData);
        } catch (error) { }
    }

    handleMarginPageByRunningType(event: MatSelectChange) {
        if (event.value === RUNNING_TYPE.FORWARD) {
            this.handleMarginPage(false);
        }
    }

    handleMarginPage(value: boolean) {
        this.showMarginPage = value;
    }

    checkBalance() {
        if (this.cardData?.cash_available != null && this.totalMargin != null) {
            this.lowBalance = this.cardData?.cash_available < Formulas.fetchTotalMargin(this.totalMargin, this.parametersForm.get('multiplier').value);
        }
        this.isDeployDisabled = ((this.isVendorLogin && this.lowBalance && this.data.portfolio.portfolioCreationType === PortfolioCreationType.Copy && this.data.portfolio.originalPortfolioDetails?.length && !!this.data.portfolio.originalPortfolioDetails[0].isPublic) || (this.data.portfolio.originalPortfolioDetails && !this.data.portfolio.originalPortfolioDetails.length && this.data.portfolio.portfolioCreationType === PortfolioCreationType.Copy));
        this.sufficientBalance = (this.isVendorLogin && !this.lowBalance && this.data.portfolio.portfolioCreationType === PortfolioCreationType.Copy && this.data.portfolio.originalPortfolioDetails?.length && !!this.data.portfolio.originalPortfolioDetails[0].isPublic);
    }

    editExitParams() {
        this.dialogRef.close();
        this.router.navigate(['/trading/strategies/create/'], { 
            queryParams: { 
                portfolioId: this.data.portfolio.portfolioID, 
                temproaryPortfolio: true, 
                editExitOnOriginals: true, 
                deployed: this.data.portfolio.deployed,
                eventOrigin: "Deploy"
            } 
        });
    }

    addFunds() {
        // Redirect to Retail Add Funds Page
        this.fundsService.getPayinUrl().subscribe(res => {
            let authLink = res.link;
            authLink = Utils.addParamToStringUrl(authLink, 'VIEW_PLATFORM', 'WEB');
            location.replace(authLink);
        });
    }

    manageBrokers() {
        this.router.navigate([MANAGE_BROKERS_PATH]);
        this.closeDialog();
    }

    multiplierClicked(isAdd: boolean) {
        if (isAdd) {
            this.parametersForm.get('multiplier').value < this.multiplierRange[1] && this.parametersForm.get('multiplier').setValue(this.parametersForm.get('multiplier').value + 1);
        } else {
            this.parametersForm.get('multiplier').value > 1 && this.parametersForm.get('multiplier').setValue(this.parametersForm.get('multiplier').value - 1);
        }
        this.parametersForm.get('multiplier').updateValueAndValidity();
    }

    getBalance() {
        this.fundsService.fetchMargin(this.authService.isSwastikaLogin, this.isMasterTrustLogin).subscribe((res: any) => {
            if (this.authService.isSwastikaLogin || this.isMasterTrustLogin) {
                this.cardData.calculateSwastikaMarginValues(res);
                this.checkBalance();
                this.balanceChecked = true;
            } else {
                const response = res.response;
                if (response.length) {
                    let uAlgoMarginRes: MarginResponse;
                    response.forEach((data) => {
                        if (data.product_id === PRODUCT_ID.ALL) {
                            this.cardData.calculateMarginValues(data);
                            this.checkBalance();
                        } else {
                            uAlgoMarginRes = data;
                        }
                    })
                    if(uAlgoMarginRes && this.fundsNewFormula){
                        this.cardData.updateMarginValues(uAlgoMarginRes, true);
                    }
                }
            }

        }, (_)=> {
            this.checkBalance();
        })
    }

    /** UT-9133: paused/unavailable brokers show override labels instead of active status. */
    isBrokerNotAvailable(broker: ConnectedBroker): boolean {
        return this.manageBrokerService.notAvailableBrokers.has(broker.broker);
    }

    isBrokerPaused(broker: ConnectedBroker): boolean {
        return this.manageBrokerService.pausedBrokers.has(broker.broker);
    }

    closeDialog() {
        this.dialogRef.close();
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    trackBySpaceId(_: number, space: AlgoSpace): string {
        return space.id;
    }
}
